import { Injectable } from '@angular/core';
import { RequestService } from '../request.service';
import { Doctor } from '../../classes/doctor';

import { Auth } from '../auth.service';
import { UserService } from '../users/user.service';

@Injectable()
export class PriorityService extends UserService {

  constructor(
    protected requestService: RequestService, 
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getOneUserUrl(): string {

    return 'priorityItem';
  };

  protected getUsersUrl(): string {

    return 'priorityItemAll';
  };

  getItems(specialtyId:string,providerId:string):Promise<Doctor[]>{
    return this.requestService.makeRequest({
      urlKey: 'priorityItemAll',
      urlQueryParams: {
        provider: providerId,
        specialty:specialtyId
      }
    })
      .then((response: any) => response.json() as Doctor);
  }

  getDoctorsWithoutPriority(specialtyId:string,providerId:string):Promise<Doctor[]>{
    return this.requestService.makeRequest({
      urlKey: 'doctorsWithoutPriority',
      urlParams: {
        provider: providerId,
        specialty:specialtyId
      }
    })
      .then((response: any) => response.json() as Doctor);
  }

  add(specialtyId:string,providerId:string,doctorId:string){
    return this.requestService.makeRequest({
      urlKey:'priorityItemAll',
      method:'post',
      body:{
        provider: providerId,
        specialty:specialtyId,
        doctor:doctorId
      }
    }).then((response: any) => response.json() as Doctor);
  }

  moveOneUp(id:string){
    console.log("Move one up");
    
    return this.requestService.makeRequest({
      urlKey:'priorityOneUp',
      method:'put',
      body:{
        id:id
      }
    })
  }
  moveOneDown(id:string){
    return this.requestService.makeRequest({
      urlKey:'priorityOneDown',
      method:'put',
      body:{
        id:id
      }
    })
  }
  moveTenUp(id:string){
    return this.requestService.makeRequest({
      urlKey:'priorityTenUp',
      method:'put',
      body:{
        id:id
      }
    })
  }
  moveTenDown(id:string){
    return this.requestService.makeRequest({
      urlKey:'priorityTenDown',
      method:'put',
      body:{
        id:id
      }
    })
  }
  putFirst(id:string){
    return this.requestService.makeRequest({
      urlKey:'priorityFirst',
      method:'put',
      body:{
        id:id
      }
    })
  }
  putLast(id:string){
    return this.requestService.makeRequest({
      urlKey:'priorityLast',
      method:'put',
      body:{
        id:id
      }
    })
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/priorities/priority.service.ts